import { render, staticRenderFns } from "./InventorySuplies.vue?vue&type=template&id=cbf19506"
import script from "./InventorySuplies.vue?vue&type=script&lang=js"
export * from "./InventorySuplies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports